import { useEffect } from "react"
import { useAppDispatch } from "../../../../store/hooks"
import { useRouteMatch } from "react-router-dom"
import { removeNewslineItem } from "../../../../api/controllers/knowledgeBase/helpers"
import { NewslineItem as NewslineItemType } from "../../../../models/knowledgeBase/newsline"
import { useAppSelector } from "../../../../store/hooks"
import { selectCurrentProjectId } from "../../../../store/projects/selectors"
import styles from "./NewslineItem.module.scss"

export interface NewslineItemProps {
    item: NewslineItemType
}

export const NewslineItem = ({ item }: NewslineItemProps) => {
    const dispatch = useAppDispatch()
    const projectId = useAppSelector(selectCurrentProjectId)
    const articlePath = `/project/${projectId}/knowledge-base/article/view/${item.ArticleCode}`
    const isArticleOpened = Boolean(useRouteMatch({ path: articlePath, exact: false }))

    useEffect(() => {
        if (isArticleOpened && item.IsHideAfterReading) {
            dispatch(removeNewslineItem(item.ArticleCode))
        }
    }, [isArticleOpened, item.IsHideAfterReading, item.ArticleCode, dispatch])

    return (
        <li className={styles.item}>
            <span className={styles.item__title}>{item.Title}</span>
        </li>
    )
}
